import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import styles from "../../../styles/home/Components/HeroSection.module.css";
import { FaYoutube } from "react-icons/fa";
import img1 from "../../../assets/images/image2.png";
import img2 from "../../../assets/images/image12.png";
import img3 from "../../../assets/images/image6.png";
import img4 from "../../../assets/images/image8.png"
import { MdGroups } from "react-icons/md";
import EventNotificationPopup from "../../../components/EventNotificationPopup";

const slides = [
  {
    image: img1,
    title: "Calvary Wide Fellowship Ministries",
    subtitle: '"I was glad when they said to me, \'Let us go to the house of the Lord.\'" — Psalm 122:1',
    badge: "Welcome",
    badgeAfter: "to",
  },
  {
    image: img2,
    title: "Experience the Miracle of Healing",
    subtitle: '"For I am the LORD who heals you." — Exodus 15:26',
    badge: "The Healer",
    badgeAfter: "as",
  },
  {
    image: img3,
    title: "Raising an Army of Intercessors",
    subtitle: '"The prayer of a righteous person is powerful and effective." — James 5:16',
    badge: "Called",
    badgeAfter: "to Pray",
  },
  {
    image: img4,
    title: "Worship That Transforms Lives",
    subtitle: '"God is Spirit, and His worshipers must worship in Spirit and in truth." — John 4:24',
    badge: "Join",
    badgeAfter: "Worship",
  },
];


export default function HeroSection() {
  const [sliderRef, setSliderRef] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleJoinCommunity = () => {
    window.location.href = "/fellowship";
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    fade: true,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
    },
  };

  return (
    <>
      <section className={styles.heroSection}>
        <Slider ref={setSliderRef} {...settings}>
          {slides.map((slide, idx) => (
            <div key={idx} className={styles.slide}>
              <img
                src={slide.image}
                alt={slide.title}
                className={styles.bgImage}
                loading={idx === 0 ? "eager" : "lazy"}
              />
              <div className={styles.overlay} />
              <div className={styles.heroContent}>
                <div className={styles.badgeRow}>
                  <span className={styles.badge}>{slide.badge}</span>
                  <span className={styles.badgeText}>{slide.badgeAfter}</span>
                </div>
                <h1 className={styles.heroTitle}>
                  {slide.title}
                </h1>
                <p className={styles.heroSubtitle}>
                  {slide.subtitle}
                </p>
                <div className={styles.heroActions}>
                  <a
                    href="https://www.youtube.com/@CMINTERNATIONAL"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.liveBtn}
                    aria-label="Watch live on YouTube"
                  >
                    <FaYoutube className={styles.liveIcon} />
                    <span>Watch Live</span>
                  </a>
                  <button
                    className={styles.worshipBtn}
                    onClick={handleJoinCommunity}
                    aria-label="Join our community"
                  >
                    <MdGroups className={styles.playIcon} />
                    <span>Join Our Community</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </section>
      <EventNotificationPopup />
    </>
  );
}